import { IonContent } from '@ionic/react'
import { PropsWithChildren } from 'react'

import { PageContentContainerNoSidebar } from './PageContentContainerNoSidebar'

interface ItemProps {
  id?: string
  header?: any
  ionClasses?: string
  ionStyle?: any
  bgClasses?: string
  overlayClasses?: string
  onScroll?: (top: number) => void
}

export const LayoutContainerNoSidebar = ({
  id,
  header,
  ionClasses,
  ionStyle,
  bgClasses,
  overlayClasses,
  onScroll,
  children
}: PropsWithChildren<ItemProps>) => (
  <IonContent
    id='ion-content-main'
    scrollEvents={!!onScroll}
    onIonScroll={(e) => {
      if (onScroll && e?.detail?.scrollTop) {
        onScroll(e?.detail?.scrollTop)
      }
    }}
    className={ionClasses}
    style={ionStyle}
    fullscreen
    forceOverscroll={false}
  >
    <PageContentContainerNoSidebar id={id} bgClasses={bgClasses} overlayClasses={overlayClasses}>
      {children}
    </PageContentContainerNoSidebar>
  </IonContent>
)
